angular.module('common.directives').directive('languageBtn', function () {
  return {
    templateUrl: './templates/languages.button.view.html?t=' + webpackHash,
    controller: 'showLanguagesCtrl',
    link: function ($scope, $element) {}
  }
})
